import React, { useEffect, useState } from "react";
import { getStatistics } from "service/Dashboard";
import product from "assets/images/product.svg";
import purchase from "assets/images/purchase.svg";
import buyer from "assets/images/buyer.svg";
import seller from "assets/images/seller.svg";

import styles from "./Statistics.module.scss";
import { Toast } from "utils/toast";

const Statistics = () => {
  const statistics = [
    {
      label: "Total Number of Products Received",
      color: "#C8D5E8",
      key: "productReceived",
      img: product,
    },
    {
      label: "Total Number of Sellers",
      color: "#C8D5E8",
      key: "TotalSeller",
      img: seller,
    },
    {
      label: "Total Number of Products Purchased",
      color: "#C9E3D6",
      key: "purchasedProduct",
      img: purchase,
    },
    {
      label: "Total Number of Buyers",
      color: "#C9E3D6",
      key: "buyers",
      img: buyer,
    },
  ];

  let [count, setCount] = useState();

  useEffect(() => {
    getStatisticsCount();
  }, []);

  const getStatisticsCount = async () => {
    try {
      let response = await getStatistics();
      if (response.status == 200) {
        setCount(response.data.data);
      }
    } catch (error) {
      Toast({ type: "error", message: error.data.message });
    }
  };

  return (
    <>
      <div className={styles.dashboard_title}>
        <b>Dashboard</b>
      </div>
      <div className={styles.statistics}>
        {statistics.map((list, index) => {
          return (
            <div key={index}>
              <div
                className={styles.statistics_box}
                style={{ background: list.color }}
              >
                {count != null ? (
                  <>
                    <div id="fade-in" className={styles.statistics_count}>
                      <b>{count[list.key]}</b>
                    </div>
                    <div id="fade-in" className={styles.statistics_label}>
                      <b>{list.label}</b>
                      <img src={list.img} />
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Statistics;
